import DynamicRestApi from '../../api/dynamicRestApi'
import Csrf from '../../api/csrf'

const state = {
	user: null,
	cid: null
}

const actions = {
	async login ({ commit }, credentials) {
		await Csrf.getCookie()
		return DynamicRestApi
			.post('/api/login', credentials)
			.then(({ data }) => {
				data.user.access_token = data.access_token
				commit('setUserData', data.user)
			})
	},

	logout ({ commit }) {
		DynamicRestApi
			.post('/api/logout')
		commit('clearUserData')
	},

	register ({ commit }, credentials) {
		return DynamicRestApi
			.post('/api/register', credentials)
	},
	verifyEmail ({ commit }, { id, hash, newMail }) {
		return DynamicRestApi
			.get('/api/email/verify/' + id + '/' + hash + '?newMail=' + newMail)
	},
	async requestPasswordReset ({ commit }, credentials) {
		await Csrf.getCookie()
		return DynamicRestApi
			.post('/api/forgot-password', credentials)
	},

	async resetPassword ({ commit }, payload) {
		await Csrf.getCookie()
		return DynamicRestApi
			.post('/api/reset-password', payload)
	},

	async getCustomer () {
		await Csrf.getCookie()

		const { customers_id } = JSON.parse(localStorage.getItem('user'))

		return DynamicRestApi
			.get(`/api/customers/${customers_id}`)
			.then(({ data }) => {
				return data
			})
	}
}

const mutations = {
	setUserData (state, userData) {
		state.user = userData
		state.cid = userData.customers_id
		localStorage.setItem('user', JSON.stringify(userData))
		DynamicRestApi.defaults.headers.common.Authorization = `Bearer ${userData.access_token}`
	},

	clearUserData () {
		localStorage.removeItem('user')
		setTimeout(() => { location.reload() }, 3000)
	}
}

export const auth = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters: {
		isLogged: state => !!state.user
	}
}
